import React, { useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";

import { useForm } from "react-hook-form";
import { useChangePassword } from "../../lib/queries/queriesAndMutations";
import CustomInput from "../../ui/CustomInput/index.js";
import { newPasswordSchema } from "../../lib/validation";
import CustomButton from "../../ui/CustomButton.jsx";

const ConfirmNewPasswordPage = () => {
  const { state } = useLocation();

  const navigate = useNavigate();

  const { mutateAsync: changePassword, isPending } = useChangePassword();

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { new_password: "", new_password2: "" },
    resolver: zodResolver(newPasswordSchema),
  });

  const processForm = async (data) => {
    const proccesdata = { ...state, ...data };

    try {
      const response = await changePassword(proccesdata);
      if (response.status === 201 || response.status === 200) {
        toast.success("رمز عبور با موفقیت تغییر یافت");
        navigate("/login");
      }
    } catch (error) {
      console.error("ConfirmNewPasswordPage", error);
    }
  };

  return (
    <div className="flex flex-col gap-3 md:gap-8 ">
      <PasswordValidation errors={errors} />

      <>
        <form
          onSubmit={handleSubmit(processForm)}
          className="flex flex-col gap-4 mt-4"
        >
          <CustomInput
            tabIndex={"8"}
            control={control}
            name={"new_password"}
            label={"رمز عبور جدید"}
            className={"order-last"}
            type={showPassword ? "text" : "password"}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            isPassword={true}
            errors={errors.new_password}
          />
          <CustomInput
            tabIndex={"8"}
            control={control}
            name={"new_password2"}
            label={"تکرار رمز عبور"}
            className={"order-last"}
            type={showPassword2 ? "text" : "password"}
            showPassword={showPassword2}
            setShowPassword={setShowPassword2}
            isPassword={true}
            errors={errors.new_password2}
          />
          <CustomButton
            type={"submit"}
            isLoading={isPending}
            className="text-[#FFFFFF] bg-dark hover:bg-[#2A7A67] py-[12px]  px-[70px] rounded-[12px] mt-4 text-[22px] w-fit mx-auto font-semibold  "
          >
            تغییر رمز عبور
          </CustomButton>
        </form>
      </>
    </div>
  );
};

export default ConfirmNewPasswordPage;

const PasswordValidation = () => {
  const validationRules = [
    "رمز عبور جدید می بایست حداقل 8 کاراکتر باشد",
    "رمز عبور جدید می بایست حداکثر 20 کاراکتر باشد",
    "رمز عبور جدید می بایست حداقل دارای یک حرف بزرگ انگلیسی باشد",
    "رمز عبور جدید می بایست حداقل دارای یک حرف کوچک انگلیسی باشد",
    "رمز عبور جدید می بایست حداقل دارای یک عدد باشد",
    "رمز عبور جدید نمی تواند شامل حروف غیر انگلیسی باشد",
    "رمز عبور جدید می بایست حداقل دارای یک کاراکتر خاص باشد",
  ];

  return (
    <div className=" text-[10px]">
      {validationRules.map((rule, index) => (
        <div key={index} className="text-zinc-400 font-semibold ">
          {rule}
        </div>
      ))}
    </div>
  );
};
